import React from 'react'
import { Select } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'

const FilterOrdinances = ({ currentOrdinanceType, setOrdinanceType, isReservationList }) => {
  const { t } = useTranslation()

  const nonReservableOrdinanceTypeOptions = ['LDS_ORDINATION', 'MELCHIZEDEK', 'MELCHIZEDEK_ELDER', 'TIME_ONLY_MARRIAGE']
  const ordinanceTypeOptions = [
    {
      value: 'all',
      label: t('artifacts.category.all', 'All'),
    },
    {
      value: 'BAPTISM',
      label: t('ordinances.types.baptism', 'Baptism'),
    },
    {
      value: 'CONFIRMATION',
      label: t('ordinances.types.confirmation', 'Confirmation'),
    },
    {
      value: 'INITIATORY',
      label: t('ordinances.types.initiatory', 'Initiatory'),
    },
    {
      value: 'ENDOWMENT',
      label: t('ordinances.types.endowment', 'Endowment'),
    },
    {
      value: 'LDS_ORDINATION',
      label: t('ordinances.types.ldsOrdination', 'LDS Ordination'),
    },
    {
      value: 'MELCHIZEDEK',
      label: t('ordinances.types.melchizedek', 'Melchizedek'),
    },
    {
      value: 'MELCHIZEDEK_ELDER',
      label: t('ordinances.types.melchizedekElder', 'Melchizedek Elder'),
    },
    {
      value: 'SEALING_TO_PARENTS',
      label: t('ordinances.types.sealingToParents', 'Sealing to Parents'),
    },
    {
      value: 'SEALING_TO_SPOUSE',
      label: t('ordinances.types.sealingToSpouse', 'Sealing to Spouse'),
    },
    {
      value: 'TIME_ONLY_MARRIAGE',
      label: t('ordinances.types.timeOnlyMarriage', 'Time-only Marriage'),
    },
  ]

  const filteredOrdinanceOptions = isReservationList
    ? ordinanceTypeOptions.filter((ord) => !nonReservableOrdinanceTypeOptions.includes(ord.value))
    : ordinanceTypeOptions

  return (
    <Select
      placeholder={t('odm.selectType', 'Select Type')}
      value={currentOrdinanceType}
      key={currentOrdinanceType}
      onChange={(e) => setOrdinanceType(e.target.value)}
      name="Ordinance Category Filter"
      options={filteredOrdinanceOptions}
    />
  )
}

export default FilterOrdinances
